module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp123_4.79385315.png";